module.exports = __webpack_public_path__ + "static/media/After-Icon.8a88aadd.svg";